package io.horion.cv.components.forms

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.style.toModifier
import io.horion.cv.components.widgets.FormActionButtons
import io.horion.cv.components.widgets.TextFormField
import io.horion.cv.models.QualityState
import io.horion.cv.styles.QualityFieldStyle
import io.horion.cv.viewModel.CvViewModel
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px

@Composable
fun QualityForm(
    index: Int,
    state: QualityState,
    cvViewModel: CvViewModel,
    onDelete: () -> Unit,
    onComplete: () -> Unit,
) {
    Column(
        modifier = Modifier
            .fillMaxWidth()
            .maxWidth(100.percent)
            .styleModifier {
                property("box-sizing", "border-box")
                property("min-width", "0")
            },
        verticalArrangement = Arrangement.spacedBy(25.px),
    ) {
        TextFormField(
            label = "Qualité",
            value = state.quality,
            onValueChange = {
                state.quality = it
                cvViewModel.updateQuality(index, it)
            },
            modifier = QualityFieldStyle.toModifier()
                .fillMaxWidth()
                .styleModifier { property("min-width", "0") }
        )

        FormActionButtons(
            onDelete = onDelete,
            onComplete = onComplete
        )
    }
}